/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", ["dashAnimation"], function () {
    // Локальные переменные
    const module = this;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    };

    var activeThumb = document.querySelector("[data-slider-name='infoThumbs'] .js-active-thumb");

    if (activeThumb) {
        window.currentActiveStroke = activeThumb.querySelector(".thumb__stroke");
        window.sliderIsPaused = false;
    }

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                    }
                }
            }
        },

        indicationsNav: {
            sliderName: "indicationsNav",
            slidesPerView: "auto",
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: true,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            preventClicksPropagation: false,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const buttons = swiperContainer.querySelectorAll("[data-filter-btn]");
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                    }

                    Array.prototype.forEach.call(buttons, function (button, index) {
                        button.addEventListener("click", function (evt) {
                            evt.preventDefault();
                            swiper.slideTo(index);
                        });
                    });
                }
            }
        },

        indications: {
            sliderName: "indications",
            slidesPerView: "auto",
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: true,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    let activeFilter = document.querySelector(".js-active-filter");
                    let activeFilterType = activeFilter.getAttribute("data-filter-btn");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                    }

                    const filterBtns = document.querySelectorAll("[data-filter-btn]");

                    const onButtonClick = function (evt) {
                        const btn = evt.currentTarget;
                        const btnType = btn.getAttribute("data-filter-btn");

                        if (activeFilterType == btnType) {
                            return;
                        }

                        activeFilter.classList.remove("js-active-filter");
                        btn.classList.add("js-active-filter");
                        activeFilter = btn;
                        activeFilterType = btnType;

                        swiper.removeAllSlides();

                        if (btnType == "all") {
                            swiper.appendSlide(clonedSlides);
                        }

                        if (btnType != "all") {
                            const typeSlides = Array.prototype.filter.call(clonedSlides, function (clonedSlide) {
                                return clonedSlide.getAttribute("data-filter-slide") == btnType;
                            });
    
                            const clonedTypeSlides = Array.prototype.map.call(typeSlides, function (typeSlide) {
                                return typeSlide.cloneNode(true);
                            });
    
                            swiper.appendSlide(clonedTypeSlides);
                        }
                    };

                    Array.prototype.forEach.call(filterBtns, function (btn) {
                        btn.addEventListener("click", onButtonClick);
                    });

                    const slides = swiper.slides;
                    const clonedSlides = Array.prototype.map.call(slides, function (slide) {
                        return slide.cloneNode(true);
                    });
                }
            }
        },

        expertArticles: {
            sliderName: "expertArticles",
            slidesPerView: "auto",
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            watchOverflow: true,
            simulateTouch: true,
            followFinger: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            runCallbacksOnInit: false
        },

    
        painSwiper: {
            sliderName: "painSwiper",
            loop: false,
            spaceBetween: 10,
            freeMode: true,
            slidesPerView: "auto",
            breakpoints: {
                768: {
                slidesPerView: 2,
                spaceBetween: 20,
                },
            },
        },
        

        enum:  {
            sliderName: "symptoms",
            slidesPerView: "auto",
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            watchOverflow: true,
            simulateTouch: true,
            followFinger: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            runCallbacksOnInit: false
        },

        releaseForm:  {
            sliderName: "releaseForm",
            slidesPerView: "auto",
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            watchOverflow: true,
            simulateTouch: true,
            followFinger: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            runCallbacksOnInit: false
        },

        substances: {
            sliderName: "substances",
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            watchOverflow: true,
            simulateTouch: false,
            followFinger: false,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            runCallbacksOnInit: false,
            on: {
                init: function () {
                    var swiper = this;
                    const swiperContainer = swiper.el;
                    var sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                    }
                },
            }
        },

        substancesNav: {
            // spaceBetween: 1,
            slidesPerView: "auto",
            watchOverflow: true,
            simulateTouch: false,
            followFinger: false,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    var sliderInitiator = this.el.closest(".js-slider-nav");
                    var sliderName = sliderInitiator.getAttribute("data-slider-name");

                    Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                }
            }
        },

        pain: {
            sliderName: "pain",
            slidesPerView: "auto",
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            watchOverflow: true,
            simulateTouch: false,
            followFinger: false,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            runCallbacksOnInit: false,
            on: {
                init: function () {
                    var swiper = this;
                    const swiperContainer = swiper.el;
                    var sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                    }

                    const slideButtons = swiperContainer.querySelectorAll(".js-slide-button");
                    const thumbsStroke = swiperContainer.querySelectorAll(".js-thumb-stroke");

                    const defaultDuration = 6;
                    let activeIndex = 0;
                    let activeAnimation = null;
                    let activeCircle = thumbsStroke[0];

                    const stopCircle = function (anim) {
                        slideButtons[activeIndex].classList.remove("js-active");

                        if (!anim) {
                            activeAnimation && activeAnimation.kill();

                            if (activeAnimation) {
                                activeAnimation = null;

                                gsap.set(activeCircle, {strokeDasharray: thumbsStroke[0].getTotalLength()}); // eslint-disable-line
                                gsap.set(activeCircle, {strokeDashoffset: thumbsStroke[0].getTotalLength()}); // eslint-disable-line
                            }
                        } else {
                            anim.kill();
                        }
                    };

                    const startCircle = function (index) {
                        stopCircle();
                        activeIndex = index;
                        slideButtons[activeIndex].classList.add("js-active");
                        Swiper.initedSliders["pain"].slideTo(index); // eslint-disable-line

                        activeCircle = thumbsStroke[index];

                        activeAnimation = gsap.to(activeCircle, { // eslint-disable-line
                            strokeDashoffset: 0,
                            duration: defaultDuration,
                            ease: "none",
                            // paused: true,
                            onComplete: function () {
                                if (index == thumbsStroke.length - 1) {
                                    Swiper.initedSliders["pain"].slideTo(0); // eslint-disable-line
                                } else {
                                    Swiper.initedSliders["pain"].slideTo(++index); // eslint-disable-line
                                }
                            },
                            clearProps: "all"
                        });
                    };

                    const initAutoSlider = function () {
                        Swiper.initedSliders["pain"].on("slideChange", function () { // eslint-disable-line
                            const swiper = this;
                            const currentActiveIndex = swiper.activeIndex;
                            startCircle(currentActiveIndex);
                        });

                        Array.prototype.forEach.call(slideButtons, function (item, index) {
                            gsap.set(thumbsStroke[index], {strokeDasharray: thumbsStroke[0].getTotalLength()}); // eslint-disable-line
                            gsap.set(thumbsStroke[index], {strokeDashoffset: thumbsStroke[0].getTotalLength()}); // eslint-disable-line

                            item.addEventListener("click", function (evt) {
                                evt.preventDefault();

                                Swiper.initedSliders["pain"].slideTo(index); // eslint-disable-line
                            });
                        });

                        startCircle(activeIndex);
                    };

                    new itsoftApp.modules.startLoad.callback(initAutoSlider, libraries.gsap);
                },
            }
        },

        painNav: {
            slidesPerView: "auto",
            watchOverflow: true,
            simulateTouch: false,
            followFinger: false,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    var sliderInitiator = this.el.closest(".js-slider-nav");
                    var sliderName = sliderInitiator.getAttribute("data-slider-name");

                    Swiper.initedSliders[sliderName] = this; // eslint-disable-line
                }
            }
        },
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});